// Removed unused: AiFillAppstore
// import { AiFillAppstore } from "react-icons/ai";
import { FaDatabase, FaPython } from "react-icons/fa";
import { GiArtificialIntelligence } from "react-icons/gi";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <FaDatabase />,
    title: "Data Science",
    des: "I work with data to extract insights using Python libraries like Pandas, NumPy, and Matplotlib.",
  },
  {
    id: 2,
    icon: <FaPython />,
    title: "Python Programming",
    des: "Proficient in Python for scripting, data wrangling, and automation in data-driven projects.",
  },
  {
    id: 3,
    icon: <GiArtificialIntelligence />,
    title: "Machine Learning",
    des: "I build and experiment with ML/DL models using Scikit-learn, TensorFlow, and PyTorch.",
  },

  // {
  //   id: 4,
  //   icon: <FaMobile />,
  //   title: "Mobile Development",
  //   des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque solutahic consequuntur eum repellendus ad",
  // },
  // {
  //   id: 5,
  //   icon: <SiAntdesign />,
  //   title: "UX Design",
  //   des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque solutahic consequuntur eum repellendus ad",
  // },
  // {
  //   id: 6,
  //   icon: <FaGlobe />,
  //   title: "Hosting Websites",
  //   des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Atque solutahic consequuntur eum repellendus ad",
  // },
];